import { Dropdown } from 'antd';
import { AntTooltip } from './AntTooltip';
import { switchIcon } from './Icons';
import { getMyProfileList } from '../../store/localstorage';
import ChangePersona from '../../pages/ChangePersona';
import { useState } from 'react';

export const NewSwitchProfileDropdown: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const profiles = getMyProfileList();
    if (!profiles || profiles.length <= 1) {
        return null;
    }

    return (
        <AntTooltip content="Switch Persona">
            <Dropdown
                overlay={<ChangePersona closeDropDown={() => setVisible(false)} />}
                trigger={['click']}
                placement="topLeft"
                className="bg-darwin-neutral_new-50 h-36 w-36 cursor-pointer justify-center flex items-center gap-8 text-neutral-black font-400 text-13 rounded-8"
                visible={visible}
                onVisibleChange={(visible) => setVisible(visible)}
            >
                <div>{switchIcon()}</div>
            </Dropdown>
        </AntTooltip>
    );
};
